'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
    displayName: 'DayOfWeek',
    render: function render() {
        return _react2.default.createElement(
            'th',
            { className: 'DayOfWeek' },
            this.props.date.format('dd')
        );
    }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-calendar-pane/lib/DayOfWeek.js
// module id = 1034
// module chunks = 0